<template>
  <div>
    <el-form :model="configForm" ref="configForm" :rules="configFormRules" label-position="right" label-width="120px">
      <el-form-item label="参数名称" prop="paramName">
        <el-input v-model="configForm.paramName" clearable style="width:100%" :disabled="operationType=='view'"></el-input>
      </el-form-item>
      <el-form-item label="参数描述" prop="paramDesc">
        <el-input v-model="configForm.paramDesc" clearable style="width:100%" :disabled="operationType=='view'"></el-input>
      </el-form-item>
      <el-form-item label="数据类型" prop="dataType">
        <ic-select table="TT_PROC" field="DATA_TYPE" clearable v-model="configForm.dataType" style="width:100%" :disabled="operationType=='view'"></ic-select>
      </el-form-item>
      <el-form-item label="选择器类型" prop="selectorType" v-if="configForm.dataType=='SELECTOR'">
        <ic-select table="TT_PROC" field="SELECTOR_TYPE" clearable v-model="configForm.selectorType" style="width:100%" :disabled="operationType=='view'"></ic-select>
      </el-form-item>
      <el-form-item label="字典" prop="selectorType" v-if="configForm.dataType=='DICT'">
        <el-input v-model="configForm.selectorType"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="uom">
        <el-input v-model="configForm.uom" clearable style="width:100%" :disabled="operationType=='view'"></el-input>
      </el-form-item>
      <el-form-item label="统计类型" prop="statsType">
        <ic-select table="TT_PROC" field="STATISTIC_TYPE" v-model="configForm.statsType" style="width:100%" :disabled="operationType=='view'"></ic-select>
      </el-form-item>
      <el-form-item label="供应商是否可见" prop="supplierViewable">
        <el-switch v-model="configForm.supplierViewable" active-text="是" inactive-text="否" :disabled="operationType=='view'" />
      </el-form-item>
      <el-form-item label="是否换行显示" prop="lineBreak">
        <el-switch v-model="configForm.lineBreak" active-text="是" inactive-text="否" :disabled="operationType=='view'" />
      </el-form-item>
      <el-form-item label="所属分组" prop="category">
        <el-input v-model="configForm.category" clearable style="width:100%" :disabled="operationType=='view'"></el-input>
      </el-form-item>
      <el-form-item label="公式定义" prop="statsExpr">
        <el-input v-model="configForm.statsExpr" type="textarea" :rows="3" placeholder="请输入公式定义" maxlength="4000" show-word-limit :disabled="operationType=='view'" />
      </el-form-item>
      <el-row type="flex" justify="center" align="middle">
        <el-button size="mini" @click="onSave" type="primary" v-if="operationType!='view'">保存</el-button>
        <el-button size="mini" @click="onCancel" type="primary">取消</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
export default {
  name: '',
  components: { IcSelect },
  props: ['curForm', 'paramNameLists', 'operationType'],
  data() {
    var validateParamName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入参数名称'));
      } else {
        if (this.paramNameMap.includes(value)) {
          callback(new Error('参数名称已存在'));
        } else {
          callback();

        }
      }
    };
    return {
      configForm: {
        paramName: "",
        paramDesc: "",
        uom: "",
        statsType: "",
        statsTypeText: "",
        supplierViewable: false,
        statsExpr: "",
        paramType: "STATISTIC",
        paramTypeText: "统计参数",
        dataType: "",
        selectorType: "",
        category: "",
        lineBreak: false,
      },
      configFormRules: {
        paramName: [
          { validator: validateParamName, trigger: 'blur' }
        ],
        statsType: [{ required: true, message: "请选择统计类型", trigger: "change" }],
        dataType: [{ required: true, message: "请选择数据类型", trigger: "change" }],
        selectorType: [{ required: true, message: "请填写", trigger: "change" }],
      },
      paramNameMap: []
    }
  },
  watch: {
    curForm: {
      handler(newV) {
        console.log("🚀 ~ handler ~ newV23231231:", newV)
        if (newV) {
          this.configForm = { ...JSON.parse(newV) }
        } else {
          this.configForm = {
            paramName: "",
            paramDesc: "",
            uom: "",
            statsType: "",
            statsTypeText: "",
            supplierViewable: false,
            statsExpr: "",
            paramType: "STATISTIC",
            paramTypeText: "统计参数",
            dataType: "",
            selectorType: "",
            category: "",
            lineBreak: false,
          }
        }
      },
      immediate: true,
    },
    paramNameLists: {
      handler(newV) {
        console.log("🚀 ~ handler ~ newV:", newV)
        if (newV) {
          this.paramNameMap = [...newV]
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    onSave() {
      this.$refs['configForm'].validate((valid) => {
        if (valid) {
          var obj = JSON.parse(JSON.stringify(this.configForm))
          this.$emit('handleSaveStatisticsConfig', obj)
        }
      })
    },
    onCancel() {
      this.configForm = {
        paramName: "",
        paramDesc: "",
        uom: "",
        statsType: "",
        paramType: "STATISTIC",
        paramTypeText: "统计参数",
        supplierViewable: false,
        statsExpr: "",
        dataType: "",
        category: "",
        lineBreak: false,
      }
      this.$refs['configForm'].resetFields()
      this.$emit('onCancelStatistics')
    }
  }
}
</script>